import React from 'react';
import { nullFn } from '../utils';

type CheckboxInputProps = {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
};

const CheckboxInput = ({
  name,
  checked = false,
  disabled = false,
  onClick = nullFn,
}: CheckboxInputProps): JSX.Element => {
  return (
    <label className='inline-flex cursor-pointer relative' htmlFor={name}>
      <input
        className='form-checkbox cursor-pointer border w-3 h-3 border-gray rounded-sm text-green focus:ring-0 focus:ring-transparent focus:outline-none focus:ring-offset-0'
        type='checkbox'
        id={name}
        name={name}
        aria-label={name}
        checked={checked}
        disabled={disabled}
        onClick={disabled ? nullFn : onClick}
        onChange={nullFn}
      />
    </label>
  );
};

export default CheckboxInput;
